var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Functions.define_WindPointLayerGroup = function (in_implements, in_extends, options) {
    var class_definition = OCS.Viewer.Functions.define_layer_group(in_implements, in_extends, options);
    return new Class({
        Extends: class_definition,
        class_name: "WindPointLayerGroup",
        style_manager_class: OCS.Viewer.Functions.define_ol_style_manager([new Class(OCS.Viewer.Interfaces.OlWindArrowStyle), new Class(OCS.Viewer.Interfaces.OlWindBarbStyle)]),
        initialize_events: function () {
            this.parent();
            this.bound_methods.update_wind_arrow_style = this.update_wind_arrow_style.bind(this);
            OCS.User.addEvent(OCS.User.options.update_user_preference_string, this.bound_methods.update_wind_arrow_style);
            this.update_wind_arrow_style();
        },
        update_wind_arrow_style: function () {
            var sm = this.get_style_manager();
            if (sm) {
                if (OCS.User.get_user_preference('wind_arrows') * 1) {
                    sm.set_style_type('wind_arrow');
                } else {
                    sm.set_style_type('wind_barb');
                }
            }
            this.fireEvent('refresh_layer_style', this);
        },
        remove_events: function() {
            OCS.User.removeEvent(OCS.User.options.update_user_preference_string, this.bound_methods.update_wind_arrow_style);
            this.parent();
        }
    });
};

